import { createStyles, makeStyles, Theme } from '@material-ui/core';

import { monochrome, backgrounds } from '../../theme/styles';

export const useStyles = makeStyles<Theme>((theme: Theme) =>
  createStyles({
    paginationRoot: {
      display: 'flex',
      border: 'none',
      '& .MuiPaginationItem-page': {
        border: `2px solid ${theme.palette.type === 'dark' ? monochrome.dark : monochrome.mediumlight}`,
        color: theme.palette.primary.main,
        fontWeight: 600,
        margin: '0 8px',
        backgroundColor: theme.palette.type === 'dark' ? backgrounds.darkModePaper : backgrounds.paper,
      },
      '& .MuiPaginationItem-page.Mui-selected': {
        border: 'none',
        color: theme.palette.type === 'dark' ? monochrome.darkest : monochrome.lightest,
        backgroundColor: theme.palette.primary.main,
      },
      '& .MuiPaginationItem-ellipsis': {
        fontSize: '13px',
        fontWeight: 600,
        color: theme.palette.primary.main,
        margin: '0 8px 9px 8px',
        padding: 0,
        minWidth: 'auto',
      },
    },
    wrapper: {
      padding: '8px',
      display: 'flex',
      width: '100%',
      alignItems: 'center',
      justifyContent: 'center',
      [theme.breakpoints.only('xs')]: {
        flexDirection: 'column-reverse',
        alignItems: 'center',
        gridGap: '8px',
        padding: 0,
      },
    },
    buttonWrapper: {
      [theme.breakpoints.only('xs')]: {
        width: 'max-content !important',
        minWidth: 'max-content !important',

        '& .MuiButton-startIcon': {
          marginRight: 0,
          marginLeft: 0,
        },
        '& .MuiButton-endIcon': {
          marginRight: 0,
          marginLeft: 0,
        },
      },
    },

    infoWrapper: {
      left: 16,
      position: 'absolute',
      display: 'flex',
      alignItems: 'center',
      [theme.breakpoints.only('xs')]: { position: 'unset' },
    },
  })
);
